module.exports = __webpack_public_path__ + "img/curved-bg.02641a12.png";